import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import useRunId from '@/hooks/useRunId.ts';
import { RetryPresentation } from '@/types/stepExecutions.ts';
import { RETRY_PRESENTATION_KEY } from '@/utils/queryKeys.ts';
import { get_run_retry_presentation_url } from '@/utils/urls.ts';

const useRetryPresentation = (
  stepRunId: string | undefined,
  enabled: boolean,
): UseQueryResult<RetryPresentation, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const runId = useRunId();

  return useQuery({
    queryKey: RETRY_PRESENTATION_KEY(automationId, runId, stepRunId),
    queryFn: async () => {
      const response = await apiClient.get(get_run_retry_presentation_url(runId, stepRunId));
      return response.data;
    },
    enabled: enabled && !!runId && !!stepRunId,
  });
};

export default useRetryPresentation;
